import styles from "./Toast.module.css"

function Toast({ message, type }) {
    return (
        <div className={`${styles.toast} ${styles['toast' + type]}`}>
            <i className={`fas ${type === 'Success' ? 'fa-circle-check' : 'fa-circle-exclamation'}`} />
            {message}
        </div>
    );
}

export default Toast;